import { render } from "./MyContracts.vue.js?vue&type=template&id=2c01bdc8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyContracts.vue?vue&type=template&id=2c01bdc8"
import script from "./MyContracts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyContracts.vue?vue&type=script&lang=js"
export * from "./MyContracts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyContracts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/MyContracts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c01bdc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c01bdc8', __exports__)) {
    api.reload('2c01bdc8', __exports__)
  }
  
  module.hot.accept("./MyContracts.vue.js?vue&type=template&id=2c01bdc8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyContracts.vue?vue&type=template&id=2c01bdc8", () => {
    api.rerender('2c01bdc8', render)
  })

}


export default __exports__